<template>
  <div class="locale-changer">
    <a
      v-for="(locale, index) in locales"
      :key="index"
      :class="[
        'locale-changer__item',
        `locale-changer__item--${locale}`,
        { 'locale-changer__item--active': activeLocale === locale }
      ]"
      @click.prevent="setActiveLocale(locale)"
    >
      {{ locale }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'LocaleChanger',
  props: {
    locales: { type: Array, required: true },
  },
  data() {
    return {
      activeLocale: 'en',
    }
  },
  methods: {
    setActiveLocale(locale) {
      this.activeLocale = locale
      this.$i18n.locale = locale
    },
  },
}
</script>
